
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetQuery from "./helper/useGetQuery"
import useUpdateMutationById from "./helper/useUpdateMutationById"

const API = {
  GET: "/api/admin/services",
  ADD: "/api/admin/services",
  UPDATE: "/api/admin/services",
  DELETE: "/api/admin/services",
};

const KEY = "SERVICES";
export const useGetServices = (params?: any) => useGetQuery(KEY, API.GET, params);
export const useAddServices = () => useAddMutation(KEY, API.ADD);
export const useUpdateServices = () => useUpdateMutationById(KEY, API.UPDATE);
export const useDeleteServices = () => useDeleteMutation(KEY, API.DELETE);
